"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _subscription = require("../../api/accessors/subscription");
var _paymentMethod = require("../../api/accessors/paymentMethod");
var _Translated = _interopRequireDefault(require("../Translated"));
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
var _SubscriptionItem = _interopRequireDefault(require("../SubscriptionItem"));
var _string = require("../../utils/string");
var _response = require("../../utils/response");
var _internalAccount = require("../../api/accessors/internalAccount");
var _dateTime = require("../../utils/dateTime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const OrderOverview = _ref => {
  let {
    plan,
    onClose,
    extraData,
    requestError,
    subscription,
    paymentMethod
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, requestError && /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    text: (0, _response.getErrorMessage)(requestError)
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 2
  }, (0, _subscription.isSubscriptionActive)(subscription) && /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    variant: "filled",
    severity: "success"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "subscribe_success",
    values: {
      date: (0, _dateTime.formattedDate)((0, _dateTime.fromTimestamp)((0, _subscription.getCurrentPeriodEnd)(subscription)))
    }
  })), (0, _subscription.isSubscriptionIncomplete)(subscription) && /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    variant: "filled",
    severity: "warning"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "subscribe_incomplete",
    values: {
      date: (0, _dateTime.formattedDate)((0, _internalAccount.getExpiresAt)((0, _subscription.getInternalUser)(subscription)))
    }
  }))), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    paragraph: true,
    variant: "h5",
    component: "h4"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "subscription_plan"
  })), /*#__PURE__*/_react.default.createElement(_SubscriptionItem.default, {
    plainText: true,
    plan: plan,
    editable: false
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Divider, null)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    paragraph: true,
    variant: "h5",
    component: "h4"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "payment_details"
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "card_type"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, (0, _string.capitalizeFirst)((0, _paymentMethod.getCardBrand)(paymentMethod)))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "card_number"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, "**** **** ****\xA0", (0, _paymentMethod.getCardLast4)(paymentMethod))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "expiry_date"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, (0, _paymentMethod.getCardExpiryMonth)(paymentMethod), "/", (0, _paymentMethod.getCardExpiryYear)(paymentMethod))), extraData && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "phone_number"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, extraData.phone)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "phone_country_code"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    gutterBottom: true
  }, extraData.countryCode)))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    onClick: onClose,
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "complete"
  }))));
};
var _default = exports.default = OrderOverview;